export const validationMessages: any = {
  'required': 'Please enter your email/username and password',
  'password': 'Please enter your password',
  'loginId': 'Please enter your email/username'
};

export const validationErrors: any = {
  'loginId': validationMessages,
  'password': validationMessages
};

export const userInfo = { 'user': {}, 'orgInfo': {}, 'role': {}, 'addl': {}, 'info': {} };

export const LOGIN_APP_TITLE = 'LOGIN_APP_TITLE';
export const NON_CLINICAL_MSG = 'NON_CLINICAL_MSG';
export const COPYRIGHT_CONTENT = 'COPYRIGHT_CONTENT';
export const FORGOT_PASSWORD_TITLE = 'FORGOT_PASSWORD_TITLE';
export const PRIVACY_NOTES_TITLE = 'PRIVACY_NOTES_TITLE';
export const LOGIN_PASSWORD_TITLE = 'LOGIN_PASSWORD_TITLE';
export const LOGIN_BUTTON_TITLE = 'LOGIN_BUTTON_TITLE';
export const LOGIN_INVALID_CREDENTIALS = 'LOGIN_INVALID_CREDENTIALS';
export const LOGIN_NAME_TITLE = 'LOGIN_NAME_TITLE';
